import React from "react";
import CrudManager from "../../../../components/common/CrudManager";
import customersService from "../../../../services/legacy/customersService";
import { faTable } from "@fortawesome/free-solid-svg-icons";

// Joins that duplicate the header row once per joined child row (e.g. one row
// per sales line). When a value here is true, CrudManager groups those rows
// back into a single visual row by default (see table-config.yml
// joins.<key>.frontend.groupDuplicateRows). Users can still toggle this from
// the grid UI; their choice is persisted per-user and overrides this default.
const JOIN_ROW_GROUPING_DEFAULTS = {};

const ContactsPageGen = ({ service, transformColumns, crudConfigOverride }) => {
  const formTabs = [{"tabId": "Overview", "label": "axFormLayout.contactperson.tabs.overview", "order": 1, "groups": [{"groupId": "Overview_MainFields", "label": "axFormLayout.contactperson.groups.overview.overview_mainfields", "order": 1, "fields": ["contactpersonid", "name", "phone", "email"]}], "fields": []}, {"tabId": "General", "label": "axFormLayout.contactperson.tabs.general", "order": 2, "groups": [{"groupId": "Identification", "label": "axFormLayout.contactperson.groups.general.identification", "order": 1, "fields": ["title"]}, {"groupId": "CompanyInformation", "label": "axFormLayout.contactperson.groups.general.companyinformation", "order": 2, "fields": ["custaccount"]}], "fields": []}, {"tabId": "ContactInfo", "label": "axFormLayout.contactperson.tabs.contactinfo", "order": 5, "groups": [{"groupId": "Business", "label": "axFormLayout.contactperson.groups.contactinfo.business", "order": 1, "fields": ["phonelocal", "cellularphone", "telefax", "url"]}], "fields": []}];

  const baseColumns = [
    {
      key: "icontactpersonid",
      label: "contacts.icontactpersonid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "text"    },
    {
      key: "contactpersonid",
      label: "contacts.id",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "custaccount",
      label: "contacts.custaccount",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "select",
      relatedService: customersService,
      optionLabel: "name",
      optionValue: "accountNum"    },
    {
      key: "name",
      label: "contacts.name",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "title",
      label: "contacts.title",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "phone",
      label: "contacts.phone",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "phone"    },
    {
      key: "phonelocal",
      label: "contacts.phonelocal",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "phone"    },
    {
      key: "cellularphone",
      label: "contacts.cellularphone",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "phone"    },
    {
      key: "telefax",
      label: "contacts.telefax",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "phone"    },
    {
      key: "email",
      label: "contacts.email",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "email"    },
    {
      key: "url",
      label: "contacts.url",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "url"    },
    {
      key: "modifieddate",
      label: "contacts.modifieddate",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: false,
      editable: false,
      disabled: false,
      type: "datetime",
      filterType: "date"    },
    {
      key: "dataAreaId",
      label: "contacts.dataAreaId",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: true,
      editable: false,
      disabled: false,
      type: "text"    },
    {
      key: "isyncstatus",
      label: "contacts.isyncstatus",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
  ];

  const columns = transformColumns ? transformColumns(baseColumns) : baseColumns;
  const initialFormData = columns.reduce((acc, col) => {
    if (
      col &&
      col.showInForm &&
      Object.prototype.hasOwnProperty.call(col, "defaultValue")
    ) {
      acc[col.key] = col.defaultValue;
    }
    return acc;
  }, {});

  const defaultCrudConfig = {
    canCreate: true,
    canEdit: true,
    canDelete: true
  };

  const crudConfig = {
    ...defaultCrudConfig,
    ...(crudConfigOverride || {})
  };

  return (
    <CrudManager
      service={service}
      columns={columns}
      entityName="contacts"
      permissionPrefix="legacy.contacts"
      icon={faTable}
      formLayout="modal"
      canCreate={crudConfig.canCreate}
      canEdit={crudConfig.canEdit}
      canDelete={crudConfig.canDelete}
      initialFilters={crudConfig.initialFilters || {}}
      initialSort={crudConfig.initialSort || null}
      gridRowStyleResolver={crudConfig.gridRowStyleResolver || null}
      joinRowGroupingDefaults={JOIN_ROW_GROUPING_DEFAULTS}
      renderForm={crudConfig.renderForm || null}
      modalClassName={crudConfig.modalClassName || ""}
      formTabs={formTabs}
      initialFormData={initialFormData}
    />
  );
};

export default ContactsPageGen;